import React from 'react';
import { styled } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const PREFIX = 'UploadingProgress';

const classes = {
    root: `${PREFIX}-root`,
    wrapper: `${PREFIX}-wrapper`
};

const Root = styled('div')({
	[`&.${classes.root}`]: {
		width: '100%',
		height: '100vh',
		backgroundColor: '#000000cc',
		position: 'absolute',
		top: 0,
		left: 0,
	},
	[`& .${classes.wrapper}`]: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '90%',
	},
});

function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
	return (
		<Box display="flex" alignItems="center">
			<Box width="100%" mr={1}>
				<LinearProgress variant="determinate" {...props} />
			</Box>
			<Box minWidth={35}>
				<Typography variant="body2" color="textSecondary">{`${Math.round(
					props.value,
				)}%`}</Typography>
			</Box>
		</Box>
	);
}

export default function UploadingProgress({ progressArray }: any) {


	// React.useEffect(() => {
	// 	const timer = setInterval(() => {
	// 		setProgress((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10));
	// 	}, 800);
	// 	return () => {
	// 		clearInterval(timer);
	// 	};
	// }, []);

	return (
        <Root className={classes.root}>
			<div className={classes.wrapper}>
				{progressArray.map((progress: any, index: number) => (
					<LinearProgressWithLabel value={progress} key={index} />
				))}
			</div>
		</Root>
    );
}
